interface HighlightParts {
    beforeText: string;
    lastCharBefore: string;
    spaceBefore: string;
    highlightText: string;
    afterHighlight: string;
    calculatedWidth: number;
}

export const parseHighlightText = (title: string, highlightWord: string): HighlightParts | null => {
    const highlightIndex = title.toLowerCase().indexOf(highlightWord.toLowerCase());

    if (highlightIndex === -1) {
        return null;
    }

    const beforeHighlight = title.substring(0, highlightIndex);
    const highlightText = title.substring(highlightIndex, highlightIndex + highlightWord.length);
    const afterHighlight = title.substring(highlightIndex + highlightWord.length);

    const wordsBefore = beforeHighlight.trim().split(/\s+/);
    const lastWordBefore = wordsBefore[wordsBefore.length - 1] || '';
    const lastCharBefore = lastWordBefore.slice(-1) || '';
    const spaceBefore = beforeHighlight.endsWith(' ') ? ' ' : '';

    const charWidth = 11;
    const calculatedWidth = highlightText.length * charWidth + 25;

    const beforeText = beforeHighlight.slice(0, -lastCharBefore.length - (spaceBefore ? 1 : 0));

    return {
        beforeText,
        lastCharBefore,
        spaceBefore,
        highlightText,
        afterHighlight,
        calculatedWidth,
    };
};
